import { withInstall } from "../../utils/install";
import StaticText from "./src/main.vue";
StaticText.name = "ltStaticText";
export const ltStaticText = withInstall(StaticText);
export default ltStaticText;
